import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhib",
  "use": "icon-zhib-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zhib\"><defs><style type=\"text/css\"></style></defs><path d=\"M793.529 323.967L495.604 634.129 293.643 440.445l-49.063 50.469 252.667 242.709 346.908-361.139z\" p-id=\"16762\" /><path d=\"M526.418 1024l-326.69-207.002L65.373 202.132 527.414 0l459.357 201.011-93.85 617.479L526.418 1024zM254.376 778.758l273.965 173.594 308.25-172.842 82.228-541.045L527.414 67.186l-391.133 171.11 118.095 540.462z\" p-id=\"16763\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/zhib.svg
// module id = 59dw
// module chunks = 1